<script lang="ts">
    import Select from "svelte-select/Select.svelte"
    export let options: { label: string; value: string }[] = [],
        selectedOption: { label: string; value: string } = null,
        value = "",
        placeholder: string,
        clearable = false,
        editMode = true

    $: value = selectedOption?.value
    $: hasValue = Boolean(value)
</script>

<!-- svelte-ignore a11y-label-has-associated-control -->
<label>
    <span class:hasValue="{hasValue || !editMode}">{placeholder}</span>
    {#if editMode}
        <Select
            bind:items="{options}"
            inputAttributes="{{ autocomplete: 'on' }}"
            placeholder="{placeholder}"
            showChevron="{true}"
            clearable="{clearable}"
            hideEmptyState="{true}"
            searchable="{true}"
            bind:value="{selectedOption}"
            on:clear="{() => (selectedOption = null)}"
        />
    {:else if !editMode}
        <div class="no-input">{selectedOption?.label || "-"}</div>
    {/if}
</label>

<style lang="less">
    :global .svelte-select {
        background-color: var(--neutral-white) !important;
        resize: none !important;
        .value-container {
            input {
                padding-top: 20px;
            }
            .selected-item {
                padding-top: 19px;
            }
        }

        .multi-item {
            background-color: rgba(0, 0, 0, 0.1) !important;
            border-radius: 3px !important;
        }

        .selected-item {
            margin-left: 3px;
            height: auto;
            line-height: 100%;
        }

        input {
            height: 100%;
            font-size: 1rem !important;
            border: 0px solid black !important;
        }
        * {
            border-left: 0px solid black !important;
        }

        .list-item {
            .item {
                &.active {
                    background-color: transparent !important;
                    color: black !important;
                }
            }
        }

        .indicators {
            color: #ccc;

            & > * {
                border-left: 1px solid #ccc !important;
                height: 40px !important;
                cursor: pointer !important;
            }

            .clear-select {
                color: var(--primary-200) !important;
                font-weight: 700 !important;
            }
        }
    }
</style>
